<bizz-macro-button [style]="column.ButtonStyle"
                       [icon]="column.ButtonIcon"
                       [caption]="column.Caption"
                       [displayType]="column.ButtonDisplayType"
                       [macroButtonType]="MacroButtonType.WidgetList"
                       [macroButtonProperties]="{data, column}"
                       [url]="value!"></bizz-macro-button>